import React, { useState, useCallback, useEffect } from "react";
import { Modal, TextContainer, Toast } from "@shopify/polaris";
import { gql } from "apollo-boost";
import { useMutation } from "@apollo/react-hooks";

import { handleError } from "../../helper";
import { LIST_SELLER_PRODUCTS_QUERY } from "./ProductsPolaris";

const DELETE_TAGS = gql`
  mutation addTagsToProducts($productIds: [ID!]!, $add: Boolean!) {
    addTagsToProducts(productIds: $productIds, add: $add)
  }
`;

export const DeleteTagsProductsPolaris = ({
  open,
  toggleModal,
  selectedItem,
  filter,
  onCompleted,
}) => {
  const [activeToast, setActiveToast] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  const [addTagsToProducts, { data, loading, error, client }] = useMutation(
    DELETE_TAGS,
    {
      onError: () => {},
    }
  );

  useEffect(() => {
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAction = useCallback(() => {
    addTagsToProducts({
      variables: {
        productIds: selectedItem,
        add: false,
      },
    })
      .then(() => {
        try {
          const cache = client.readQuery({
            query: LIST_SELLER_PRODUCTS_QUERY,
            variables: { filter },
          });
          client.writeQuery({
            query: LIST_SELLER_PRODUCTS_QUERY,
            variables: { filter },
            data: {
              ...cache,
              products: {
                ...cache.products,
                nodes: cache.products.nodes.map(
                  (product) => (
                    selectedItem.find((s) => s === product.id)
                      ? (product.tags = [])
                      : null,
                    product
                  )
                ),
              },
            },
          });
        } catch (e) {}
      })
      .catch(() => {});
    toggleActive();
    const id = setTimeout(() => {
      toggleModal();
      onCompleted();
    }, 2500);
    setTimeoutId(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);

  const toggleActive = useCallback(
    () => setActiveToast((activeToast) => !activeToast),
    []
  );

  const toastMarkup = activeToast
    ? (error || (data && data.addTagsToProducts)) && (
        <Toast
          content={
            error
              ? handleError(error.toString())
              : data && data.addTagsToProducts && "Remove tags success."
          }
          error={error}
          duration={2000}
          onDismiss={toggleActive}
        />
      )
    : null;

  return (
    <>
      {toastMarkup}
      <Modal
        title="Remove tags"
        open={open}
        onClose={toggleModal}
        sectioned
        secondaryActions={[{ content: "No", onAction: toggleModal }]}
        primaryAction={{
          content: "Yes",
          onAction: handleAction,
          loading: loading,
        }}
      >
        <TextContainer>Are you sure to remove tags?</TextContainer>
      </Modal>
    </>
  );
};
